import React from "react";
import Sidebar from "../components/sidebar/sidebarcse";
const dashboard = () => {
  return (
    <>
      <div>
        <Sidebar></Sidebar>
      </div>
    </>
  );
};

export default dashboard;
